<form>
  <h3>{{ 'speedReading.parameters.fontSettings' | translate }}</h3>

  @if (availableParameters.fontFamily) {
    <ms-form-field appearance="flat" color="darkOrange">
      <ms-label>{{ 'speedReading.parameters.fontSettings.fontFamily' | translate }}</ms-label>
      <ms-select class="font-family-select" [style.fontFamily]="parameters.font" gameParameter="font">
        @for (font of fonts; track font) {
          <ms-option class="font-family-option" [style.fontFamily]="font.family" [value]="font.family">
            {{ font.family }}
          </ms-option>
        }
      </ms-select>
    </ms-form-field>
  }

  @if (availableParameters.fontSize) {
    <ms-form-field appearance="flat" color="darkWater">
      <ms-label>{{ 'speedReading.parameters.fontSettings.fontSize' | translate }}</ms-label>
      <ms-select class="font-size-select" gameParameter="fontSize" gameParameterType="number">
        <ms-option class="font-size-option" *ngFor="let fontSize of fontSizeOptions" [value]="fontSize">
          {{ fontSize }}%
        </ms-option>
      </ms-select>
    </ms-form-field>
  }

  @if (availableParameters.fontWeight) {
    <ms-form-field appearance="flat" color="earth">
      <ms-label>{{ 'speedReading.parameters.fontSettings.fontWeight' | translate }}</ms-label>
      <ms-select
        [style.fontFamily]="parameters.font"
        [style.fontWeight]="parameters.fontWeight"
        gameParameter="fontWeight"
      >
        <ms-option
          [style.fontFamily]="parameters.font"
          [style.fontWeight]="fontWeight"
          *ngFor="let fontWeight of fontWeightOptions"
          [value]="fontWeight"
        >
          {{ ('fontParameters.fontWeight.' + fontWeight) | translate }}
        </ms-option>
      </ms-select>
    </ms-form-field>
  }
</form>
